export default __webpack_public_path__ + "media/2.c13e5.png";